import React from 'react';

const Award = ({ data }) => (
  <section className="mb-5">
    <h1 className="section-header mb-5">Awards and Honors</h1>
    {data &&
      data.map(item => (
        <div className="my-2" key={item.name}>
          <h2 className="item-header text-lg">{item.name}</h2>
          <h3 className="item-sub">{item.organization}</h3>
          <p className="text-sm text-neutral-500 font-light">{item.date}</p>
        </div>
      ))}
  </section>
);

export default Award;
